<template>
  <b-container>
    <b-row>
      <b-col cols="10"> </b-col>
      <b-col cols="2" class="spinner_col"
        v-if="$store.state.module.live_en_cours && $store.state.fin_selected_course === 'NON'">
        <SpinnerLive></SpinnerLive>
      </b-col>
    </b-row>

    <b-row v-if="$store.getters['authAdmin/hasAdminRights']">
      <b-col md="12" class="content_container">
        <transition name="fade">
          <CarteLivePCCourse></CarteLivePCCourse>
        </transition>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="12" class="content_container">
        <transition name="fade">
          <CarteLive></CarteLive>
        </transition>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CarteLive from "../components/Live_tab/CarteLive.vue";
import CarteLivePCCourse from "../components/Live_tab/PCCourse/CarteLive.vue";
import SpinnerLive from "@/components/Live_tab/SpinnerLive.vue";

export default {
  components: {
    CarteLive,
    CarteLivePCCourse,
    SpinnerLive,
  },
  data() {
    return {};
  },
  mounted() {
    //this.$router.push({ name: "Live" });
  },
};
</script>

<style lang="sass">
</style>